import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ApplicantsReportsModel } from 'common/models/page-models/reports/applicant-reports/applicant-report-data-model';
import { ApplicantReportsListingModel } from 'common/models/page-models/reports/applicant-reports/applicant-report-grid-model';
import { GridResolver } from 'common/resolvers/core-resolvers/grid.resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { ApplicantReportsWidgetService } from 'common/widget/reports/applicants-report-widget.service';
 
@Injectable({
    providedIn: 'root'
})
export class ApplicantReportsResolver extends GridResolver<ApplicantsReportsModel, ApplicantReportsListingModel> {
    constructor(
        protected fs: ApplicantReportsWidgetService,
        protected override  router: Router,
        protected override  systemService: SystemService
    ) {
        super(fs, router, systemService);
    }

     override modifyResponseData(dataModel: any, meta: any, widget: any) {
        dataModel['filterData'] = new ApplicantsReportsModel();
        return dataModel;
    }
}